var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.mediaOnPage)?_c('virtual-media-component'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }